import React from "react"
import Chart from "chart.js"
import { ChartBaseProps, ChartHelper } from "./chartsHelper";
export interface DoughnutProps extends ChartBaseProps {
    data: number[];
    labels: string[]
    type?: "doughnut" | "pie";
}

export class DoughnutChart extends React.Component<DoughnutProps>{
    chartComponent: HTMLCanvasElement;

    componentDidMount() {
        const colorScheme = ChartHelper.getColorScheme(this.props.colorscheme || 1);
        new Chart(this.chartComponent, {
            type: this.props.type || "doughnut",
            data: {
                labels: this.props.labels,
                datasets: [{
                    data: this.props.data,
                    backgroundColor: colorScheme
                }],
            },
            options: {
                title: {
                    display: this.props.title ? true : false,
                    position: "top",
                    text: this.props.title,
                },
                legend: { display: false },
                responsive: true,

            }
        } as Chart.ChartConfiguration);
    }

    render() {
        return (
            <canvas
                ref={input => this.chartComponent = input!}>
            </canvas>
        );
    }
}